import { render, staticRenderFns } from "./ValidacaoRouter.vue?vue&type=template&id=3cb3d000"
import script from "./ValidacaoRouter.vue?vue&type=script&lang=js"
export * from "./ValidacaoRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports